import { render } from "./copyingAlert.html?vue&type=template&id=658c8580&scoped=true&ts=true&external"
import script from "./CopyingAlert.vue?vue&type=script&lang=ts"
export * from "./CopyingAlert.vue?vue&type=script&lang=ts"

import "./CopyingAlert.vue?vue&type=style&index=0&id=658c8580&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658c8580"]])

export default __exports__